import {
  tagFormatter,
  statusFormatter,
  portIntegrationsFormatter,
  orderIDRenderer,
  shipmentIDRenderer,
  marginFormatter,
  deliveryOrderFormatter,
  checkedFormatter,
  lineSeparatedStringFormatter,
} from '../formatters';
import TextFilterWithExclude from '../customFilters/TextFilterWithExclude';
import TextFilter from '../customFilters/TextFilter';
import BillingStatusRenderer from '../../../v2/BillingStatusRenderer';

export const frameworkComponents = {
  deliveryOrderFormatter,
  statusFormatter: statusFormatter,
  portIntegrationsFormatter: portIntegrationsFormatter,
  checkedFormatter: checkedFormatter,
  lineSeparatedStringFormatter: lineSeparatedStringFormatter,
  tagFormatter: tagFormatter,
  orderIDRenderer: orderIDRenderer,
  shipmentIDRenderer: shipmentIDRenderer,
  marginFormatter: marginFormatter,
  textFilterWithExclude: TextFilterWithExclude,
  textFilter: TextFilter,
  billingStatusRenderer: BillingStatusRenderer,
};
